const permitir_consultar_matricula_diaria_por_ensino = {
  path: "/permitir-consultar-matricula-diaria-por-ensino",
  redirect: "/permitir_consultar_matricula_diaria_por_ensino",
  meta: {
    breadCrumb: "Processo de Matrículas - Permitir Consultar Matrículas Diária",
  },
  children: [
    {
      path: "/permitir-consultar-matricula-diaria-por-ensino",
      name: "permitir_consultar_matricula_diaria_por_ensino",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEnsino/PermitirConsultarMatriculaDiariaPorEnsino.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-ensino/coordenadoria/:coordenadoria_id/resens-ensino/:resens_ensino_id",
      name: "permitir_consultar_matricula_diaria_por_ensino_visualizar_ensino",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEnsino/PermitirConsultarMatriculaDiariaPorEnsinoVisualizarEnsino.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-ensino/coordenadoria/:coordenadoria_id/resens-ensino/:resens_ensino_id/resens-turno/:resens_turno_id",
      name: "permitir_consultar_matricula_diaria_por_ensino_visualizar_turno",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEnsino/PermitirConsultarMatriculaDiariaPorEnsinoVisualizarTurno.vue"
        ),
    },
    {
      path: "/permitir-consultar-matricula-diaria-por-ensino/coordenadoria/:coordenadoria_id",
      name: "permitir_consultar_matricula_diaria_por_ensino_visualizar_coordenadoria",
      component: () =>
        import(
          "@/views/PermitirConsultarMatriculaDiariaPorEnsino/PermitirConsultarMatriculaDiariaPorEnsinoVisualizarCoordenadoria.vue"
        ),
    },
  ],
};

export { permitir_consultar_matricula_diaria_por_ensino };
